module.exports = __webpack_public_path__ + "static/media/atlantic.1651fe21.png";